import type { ScreenBase } from "@frui.ts/screens/dist";
import { ConductorOneChildActive, Router } from "@frui.ts/screens/dist";
import { Modules } from "config";
import { computed } from "mobx";
import LocalizationService from "services/localizationService";
import MobileControlReportsListViewModel from "./mobileControlReports/mobileControlReportsListViewModel";
import StaticControlReportsListViewModel from "./staticControlReports/staticControlReportsListViewModel";

const navigationName = "reporting";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [StaticControlReportsListViewModel, MobileControlReportsListViewModel],
})
export default class EnforcementReportsViewModel extends ConductorOneChildActive<ScreenBase> {
  constructor(
    private localizationService: LocalizationService,
    private staticControlReportsListViewModel: StaticControlReportsListViewModel,
    private mobileControlReportsListViewModel: MobileControlReportsListViewModel
  ) {
    super();
    this.navigationName = navigationName;

    this.children.push(this.staticControlReportsListViewModel, this.mobileControlReportsListViewModel);
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.enforcement, `enforcementReports.${code}`, size);
  }

  @computed
  get name() {
    return this.translate("name");
  }
}
